import { CallSession, CallType } from "../models/callSession";

export class CallSessionHelper {
	public static resourceName(session: CallSession | null): string | undefined {
		if (!session) {
			return undefined;
		}

		return session.callType === CallType.Outgoing
			? [session.queueName, session.internalMediaIdentificationName]
					.filter((name: string | undefined) => !!name)
					.join(" | ")
			: session.queueName;
	}
}
